import { render } from "./SingleTicket.vue?vue&type=template&id=924020e4"
import script from "./SingleTicket.vue?vue&type=script&lang=js"
export * from "./SingleTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__